import $ from 'jquery';
import EventListingClass from '../EventListingViewClasses';

function makeResultsDateRangeHeading(formattedDateString) {
  if (formattedDateString === '') {
    return '<h3 class="sr-only">Results</h3>';
  }

  return `<h3 tabindex="0" class="${EventListingClass.RESULTS_HEADING}">${formattedDateString}</h3>`;
}

function makeNoResultsHtml(formattedDateString) {
  return `
    ${makeResultsDateRangeHeading(formattedDateString)}
    <div class="${EventListingClass.BASE}__no-results-container">
      <div class="${EventListingClass.BASE}__no-results-content">
        ${$('#tn-event-listing-no-results-message-template').html()}
      </div>
    </div>
  `;
}

let busyIndicatorMessage;

function makeBusyIndicatorHtml() {
  if (!busyIndicatorMessage) {
    busyIndicatorMessage = $('#tn-event-listing-loading-message-template').html();
  }

  return `
    <div class="tn-event-listing-busy-indicator">
      <div class="tn-event-listing-busy-indicator__content">${busyIndicatorMessage}</div>
    </div>
  `;
}

export {
  makeNoResultsHtml,
  makeResultsDateRangeHeading,
  makeBusyIndicatorHtml,
};



// WEBPACK FOOTER //
// ./V7/events/listing/htmlShared/index.js